import { Form } from 'react-bootstrap';

import type { FiscalExtraWeek } from 'utils/fiscalPeriods';

interface Props {
  readonly extraWeek: FiscalExtraWeek;
}

/** Read-only control documenting where a 53rd week is appended. */
export const ExtraWeekField = ({ extraWeek }: Props) => (
  <Form.Group className="mb-4" controlId="fiscal-extra-week">
    <Form.Label>53rd week</Form.Label>
    <Form.Select value={extraWeek} disabled>
      <option value="last_period">Append to the last period of Q4</option>
    </Form.Select>
    <Form.Text className="text-muted">
      52 weeks = 364 days, ~1.25 days short of a solar year, so roughly every 5–6 years the year grows to 53 weeks. Convention — and most ERPs — attach that
      week to the end.
    </Form.Text>
  </Form.Group>
);
